import {GameUtils} from "../utils/GameUtils";
import {HOTB} from "../HOTB";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {ExtendedGameMode} from "../server/ExtendedGameMode";
import {GameConfig} from "../GameConfig";

export class XBetChangeHandler {
    constructor() {
        this.init();
    }

    private init(): void {
        HOTB.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, () => this.onSelectedFeatureBetChanged());
        if (GameUtils.isBoostedBetAllowed()) {
            HOTB.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data: any) => this.onActionSpinExit(data));
        }
    }

    private onActionSpinExit(data: any): void {
        GameConfig.isBackFromAS = !!data;
    }

    private onSelectedFeatureBetChanged(): void {
        if (!(HOTB.model.isRestore)) {
            const activeBetFeature: BetFeature | undefined = GameUtils.getActiveBetFeature();

            let showReelArea: boolean;

            if (activeBetFeature?.name === "SATAN_SPINS") {
                HOTB.gameBackground.toggleSatanBackground(true);
                if (GameConfig.PREV_XBET_TYPE === ExtendedGameMode.CAPWIN_GAME) {
                    HOTB.pickAndClickView.hideBBIntro();
                }
                HOTB.satanSpinView.showBBIntro();
                showReelArea = false;
                HOTB.gameOverlay.toggleTrimmedOverlay(false);
            } else if (activeBetFeature?.name === ExtendedGameMode.CAPWIN_GAME) {
                HOTB.gameBackground.toggleSatanBackground(false);
                HOTB.pickAndClickView.showBBIntro();
                showReelArea = false;
                if (GameConfig.PREV_XBET_TYPE === "SATAN_SPINS") {
                    HOTB.satanSpinView.hideBBIntro();
                    HOTB.gameBackground.setTanksIdleTimeline();
                }
                HOTB.gameOverlay.toggleTrimmedOverlay(!showReelArea);
            } else {
                HOTB.gameBackground.toggleSatanBackground(false);
                showReelArea = true;
                if (GameConfig.PREV_XBET_TYPE === "SATAN_SPINS") {
                    HOTB.satanSpinView.hideBBIntro();
                    HOTB.gameBackground.setTanksIdleTimeline();
                }
                if (GameConfig.PREV_XBET_TYPE === ExtendedGameMode.CAPWIN_GAME) {
                    HOTB.pickAndClickView.hideBBIntro();
                    HOTB.topReel.hideIfPrevCapGame();
                }
                HOTB.gameOverlay.toggleTrimmedOverlay(!showReelArea);
            }
            if (!HOTB.apiPlugin.isReplay) {
                HOTB.soundPlayer.switchMusic(HOTB.model.data.nextMode);
            }

            GameConfig.PREV_XBET_TYPE = activeBetFeature?.name;
            GameUtils.toggleSymbols(showReelArea);
        }
    }
}